window.addEventListener("pplrAppInitiated", function (e) {
  const input = document.querySelector(".pplr_text");

  if (input) {
    const allowedCharsRegex = /[^A-Za-zäöüÄÖÜß0-9 \-]/g;

    input.addEventListener("input", function () {
      const original = input.value;
      const cleaned = original.replace(allowedCharsRegex, "");
      if (original !== cleaned) {
        input.value = cleaned;
      }
    });
  }
});